import { useHistory, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useScenarioCreateMutation } from "src/hooks";
import { useCase } from "src/hooks/useCase";
import { ScenarioForm, ScenarioFormData } from "src/forms/ScenarioForm";

interface Props {
  onClose: () => void;
}

export function ScenarioCreatePage(props: Props) {
  const { t } = useTranslation();
  const params = useParams<{ caseId: string }>();
  const history = useHistory();
  const { data: acase } = useCase(params.caseId);
  const createMutation = useScenarioCreateMutation(params.caseId);

  /**
   * Functions
   */
  async function handleSave(values: ScenarioFormData) {
    const result = await createMutation.mutateAsync(values);
    history.push(`/cases/${params.caseId}/scenarios/${result.id}`);
  }

  return render();

  function render() {
    if (!acase) return null;

    return (
      <>
        <ScenarioForm
          title={t("label.addScenario")}
          data={{ name: "" }}
          onClose={() => props.onClose}
          onSubmit={handleSave}
          isLoading={createMutation.isLoading}
        />
      </>
    );
  }
}
